import type { ChangeEvent, FocusEvent } from "react";

import { getSanitizedHtml } from "../../../handlers/utilityFunctions";
import { Label } from "../../ui/label";

interface SelectOption {
	value: string;
	name: string;
}

interface SelectFieldProps {
	onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
	value?: string;
	id?: string;
	disabled?: boolean;
	name?: string;
	error?: string | null;
	label?: string;
	options?: SelectOption[];
	onFocus?: (e: FocusEvent<HTMLSelectElement>) => void;
}

function SelectField({
	onChange,
	value,
	id,
	disabled,
	name,
	error,
	label,
	options = [],
	onFocus = () => {},
}: SelectFieldProps) {
	return (
		<div className="space-y-1">
			{label && <Label className="text-sm">{label}</Label>}
			<select
				className="flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm transition-colors focus-visible:outline-hidden"
				name={name}
				id={id}
				value={value}
				onChange={onChange}
				onFocus={onFocus}
				disabled={disabled}
			>
				{options.map((option, index) => (
					<option value={option.value} key={index}>
						{option.name}
					</option>
				))}
			</select>
			{error && <div className="text-sm font-medium text-red-500">{getSanitizedHtml(error)}</div>}
		</div>
	);
}

export default SelectField;
